import { cn } from "@/lib/utils";
import { Sparkles } from "lucide-react";
interface GoogleAIFundBadgeProps {
  variant?: "compact" | "featured" | "minimal";
  className?: string;
}
export function GoogleAIFundBadge({
  variant = "compact",
  className
}: GoogleAIFundBadgeProps) {
  if (variant === "minimal") {
    return <span className={cn("text-sm text-muted-foreground", className)}>Shortlisted: Google AI Future Fund 2026</span>;
  }
  if (variant === "featured") {
    return <div className={cn("inline-flex items-center gap-4 px-6 py-4 rounded-2xl", "bg-gradient-to-r from-blue-50 via-white to-amber-50", "border-2 border-blue-200/60", "shadow-[0_4px_20px_rgba(59,130,246,0.15)]", "hover:shadow-[0_8px_30px_rgba(59,130,246,0.25)] hover:border-blue-300/80", "transition-all duration-300", className)}>
        
        <div className="flex flex-col gap-0.5">
          <span className="text-base font-bold text-slate-900 leading-tight tracking-tight">Shortlisted: Google AI Future Fund</span>
          <span className="text-sm font-medium text-blue-600 leading-tight">2026 Cohort</span>
        </div>
      </div>;
  }

  // Default: compact variant
  return <div className={cn("inline-flex items-center gap-2 px-3 py-1.5 rounded-full", "bg-white border border-slate-200", "shadow-sm hover:shadow transition-shadow duration-200", className)}>
      <span className="text-xs font-medium text-slate-700">Shortlisted: Google AI Future Fund 2026</span>
    </div>;
}